import { render } from "./TagsView.vue?vue&type=template&id=7c1d4062&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"

import "../style/TagsViewStyle.css?vue&type=style&index=0&id=7c1d4062&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1d4062"]])

export default __exports__